var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.7,
    y: 18.6998,
    width: 17.4,
    height: 17.3999,
    rx: 8.69995,
    transform: "rotate(-180 18.7 18.6998)",
    fill: "white",
    stroke: "#F0F0F0",
    strokeWidth: 2.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_66_686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 17.4999C14.1421 17.4999 17.5 14.1421 17.5 9.99995C17.5 5.85784 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85784 2.5 9.99995C2.5 14.1421 5.85786 17.4999 10 17.4999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0335 12.6087C17.335 11.7962 17.5 10.9174 17.5 10C17.5 9.08263 17.335 8.20384 17.0335 7.39136H2.96649C2.66503 8.20384 2.5 9.08263 2.5 10C2.5 10.9174 2.66503 11.7962 2.96649 12.6087L10 13.2609L17.0335 12.6087Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 17.4999C13.225 17.4999 15.9741 15.4646 17.0338 12.6086H2.9668C4.02649 15.4646 6.77556 17.4999 10.0003 17.4999Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_66_686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 14.9999,
    fill: "white",
    transform: "translate(2.5 2.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRu);
export default __webpack_public_path__ + "static/media/ru.b87d3c029ddb017bf6176e5068a76cfd.svg";
export { ForwardRef as ReactComponent };